import { render } from "./shoppingCart.vue?vue&type=template&id=1f36f8eb&scoped=true&ts=true"
import script from "./shoppingCart.vue?vue&type=script&lang=ts"
export * from "./shoppingCart.vue?vue&type=script&lang=ts"

import "./shoppingCart.vue?vue&type=style&index=0&id=1f36f8eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f36f8eb"]])

export default __exports__